/**
 * useHotspotNotes — S10-13
 *
 * Wrapper hook around useNotes() that filters for Hotspot target_type
 * and uses the hotspot ID as originId.
 */
import { useNotes } from '../notes/useNotes'

export function useHotspotNotes(hotspotId: string | number) {
  return useNotes({
    originType: 'Hotspot',
    // SWEEP-04: originId ist jetzt number; Hotspot-ID kann als String aus der
    // Route kommen -> an der Grenze coercen (NaN-Guard liegt in useNotes).
    originId: Number(hotspotId),
  })
}
